import { render } from "./Detail.vue?vue&type=template&id=28ed1518&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=28ed1518&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/elyosdigital.com/_build/workspace/MySchool/myschool.elyosdigital.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ed1518"],['__file',"resources/js/pages/superAdmin/ecole/Detail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28ed1518"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28ed1518', __exports__)) {
    console.log('reload')
    api.reload('28ed1518', __exports__)
  }
  
  module.hot.accept("./Detail.vue?vue&type=template&id=28ed1518&scoped=true", () => {
    console.log('re-render')
    api.rerender('28ed1518', render)
  })

}


export default __exports__